import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';

export const CalendarIcon = (props: { color?: string }) => {
  return (
    <FontAwesomeIcon icon={faCalendar} color={props.color || 'black'} />
  )
}
